import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-2xl-desk max-sm:heading-2xl',
    header: 'mb-10 max-sm:flex max-sm:justify-between max-sm:gap-3',
    mobileCloseButton: '-mt-2 hidden size-10 p-0 max-sm:block',
    closeIcon: 'size-8',
    form: 'mt-8 max-sm:mt-6',
    closeButton: 'max-sm:hidden',
    content: 'py-6'
  }
});
